module.exports = {
  BRANCH_CODE: {
    key: "branch_code",
    logicalName: "店番号"
  },
  ACCOUNT_NUMBER: { key: "account_number", logicalName: "口座番号" },
  CIF_NUMBER: { key: "cif_number", logicalName: "CIF番号" },
  NAME_KANA: { key: "kana_name", logicalName: "カナ氏名" },
  RECEIPT_NUMBEAR: { key: "receipt_number", logicalName: "受付番号" },
  ENTRY_STATUS: { key: "entry_status", logicalName: "口座開設ステータス" },
  APP_STATUS: { key: "active_status", logicalName: "アプリ状態" },
  APP_STATUS_MEMO: { key: "prohibition_registered_by", logicalName: "" },
  PROHIBIT_STATUS: { key: "is_prohibited", logicalName: "" },
  INHERIT_STATUS: { key: "is_inherited", logicalName: "アプリ引継設定状態" },
  INHERIT_AT: { key: "expired_at", logicalName: "アプリ引継設定有効期限" },
  LOCK_STATUS: { key: "is_locked", logicalName: "アプリロック状態" },
  APPLICATIONIDS: { key: "applicationids", logicalName: "" }
};
